import React, { useState } from "react";
import { Row, Col, Form, message, Input, Button, Spin } from "antd";
import firebase from "../../config/FirebaseConfig";
import { useHistory } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const handleFinish = (value) => {
    setLoading(true);
    firebase
      .auth()
      .signInWithEmailAndPassword(value.email, value.password)
      .then(() => {
        firebase
          .firestore()
          .collection("users")
          .doc("admin")
          .get()
          .then((doc) => {
            const user = doc.data();
            console.log("doc",doc)
            if (
              user.email === value.email &&
              user.password === value.password
            ) {
              setLoading(false);
              message.success("Anda berhasil login");
              localStorage.setItem("isLogin", true);
              localStorage.setItem("user", user);
              history.push("/dashboard");
            }
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
            message.error(err.message);
          });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        message.error(err.message);
      });
  };

  return (
    <section
      id="login"
      style={{
        backgroundColor: "#00A0EA",
        minHeight: "100vh",
      }}
    >
      <Row
        style={{
          paddingLeft: "5vh",
          paddingTop: "3vh",
        }}
      >
        <Col>
          <img
            alt="logo"
            src={process.env.PUBLIC_URL + "/asset/logo.png"}
            style={{
              width: "240px",
              height: "auto",
            }}
          />
        </Col>
      </Row>
      <Row
        justify="center"
        align="middle"
        style={{
          paddingTop: "15vh",
        }}
      >
        <Col>
          <div className="header">Sign In to Admin Panel</div>
          <div className="subheader">
            Welcome back! Please sign in to access admin panel.
          </div>
          <Form {...layout} onFinish={handleFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Masukkan emailmu",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Masukkan passwordmu",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <Button htmlType="submit" className="btn_login">
                <span>{loading ? <Spin /> : null} &nbsp; Sign In</span>
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </section>
  );
}
